import { Reducer } from "redux";

import ContentDialogState from "./ContentDialogState";
import { ContentDialogActionTypes, ContentDialogActions } from "./ContentDialogActionTypes";

const initialState: ContentDialogState = {
  showDialog: false,
  title: "",
  renderContent: undefined,
  size: undefined,
  closable: true,
  animated: true
};

const ContentDialogReducer: Reducer<ContentDialogState, ContentDialogActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ContentDialogActionTypes.SET_CONTENT_DIALOG: {
      return {
        ...state,
        ...action.data
      };
    }
    default: {
      return state;
    }
  }
};

export default ContentDialogReducer;
